import { useEffect, useState } from "react";

const MapView = ({ latitude, longitude }) => {
  const [address, setAddress] = useState("");

  // Load the Google Maps API dynamically
  const loadGoogleMapsAPI = (lat, lon) => {
    const script = document.createElement("script");
    const googleMapKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapKey}&callback=initMap`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    window.initMap = () => initialize(lat, lon);
  };

  // Initialize the map
  const initialize = (lat, lon) => {
    const latLng = new window.google.maps.LatLng(lat, lon);
    const map = new window.google.maps.Map(document.getElementById("map"), {
      center: latLng,
      zoom: 13,
    });

    const marker = new window.google.maps.Marker({
      map: map,
      position: latLng,
      draggable: false,
    });

    const infowindow = new window.google.maps.InfoWindow();
    const geocoder = new window.google.maps.Geocoder();

    window.google.maps.event.addListener(marker, "click", () => {
      geocoder.geocode(
        { location: marker.getPosition() },
        (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              const iwContent = `
              <div id="iw_container">
                <div class="iw_title"><b>Location</b>: ${results[0].formatted_address}</div>
              </div>
            `;
              infowindow.setContent(iwContent);
              infowindow.open(map, marker);
              setAddress(results[0].formatted_address);
            } else {
              infowindow.setContent("<div>No address found</div>");
              infowindow.open(map, marker);
            }
          } else {
            infowindow.setContent(
              "<div>Geocoder failed due to: " + status + "</div>"
            );
            infowindow.open(map, marker);
          }
        }
      );
    });
  };

  useEffect(() => {
    if (latitude && longitude) {
      loadGoogleMapsAPI(latitude, longitude);
    }
    // eslint-disable-next-line
  }, [latitude, longitude]);

  return (
    <div>
      <div id="map" style={{ height: "400px", width: "100%" }}></div>
      <div>
        {address ? (
          <p>
            <b>Address:</b> {address}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default MapView;
